import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass({ mini: true })
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "close-icon"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "logo-wrapper" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "sidebar" }
const _hoisted_10 = { class: "menu-top" }
const _hoisted_11 = ["id", "title"]
const _hoisted_12 = ["onClick", "target"]
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 0,
  class: "active-icon"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "menu-item-svg"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "active-icon"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 1,
  class: "menu-item-svg"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = ["src"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "active-icon"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 1,
  class: "menu-item-svg"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "menu-bottom" }
const _hoisted_31 = ["href", "onClick"]
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "user-detail" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["src"]
const _hoisted_37 = ["src"]
const _hoisted_38 = ["src"]
const _hoisted_39 = ["src"]
const _hoisted_40 = { slot: "body" }
const _hoisted_41 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppDialog = _resolveComponent("AppDialog")!
  const _component_AlertPopup = _resolveComponent("AlertPopup")!
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
      class: "action-wrapper"
    }, [
      (!_ctx.isMenuOpen)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _withDirectives(_createElementVNode("img", {
              src: _ctx.hamburgerIcon,
              alt: "svg image"
            }, null, 8, _hoisted_3), [
              [_directive_svg_inline]
            ])
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _withDirectives(_createElementVNode("img", {
              src: _ctx.closeIcon,
              alt: "svg image"
            }, null, 8, _hoisted_5), [
              [_directive_svg_inline]
            ])
          ]))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.imageType === 'svg')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "logo",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args)))
          }, [
            _createElementVNode("div", { innerHTML: _ctx.logo }, null, 8, _hoisted_7)
          ]))
        : (_ctx.imageType === 'others')
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args))),
              src: _ctx.logo,
              alt: " image",
              class: "logo"
            }, null, 8, _hoisted_8))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("nav", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["sidebar-wrapper", { 'open': _ctx.isMenuOpen }])
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.header, ({ disable, event, href, path, target, icon, iconActive, label, dropdown, iconDown }, index) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: index,
                to: path,
                class: "link",
                active: _ctx.isActive,
                href: href,
                onClick: _ctx.navigate
              }, {
                default: _withCtx(({ href, navigate, isActive }) => [
                  (!disable)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        id: `nav-item-${index}`,
                        class: _normalizeClass([{ 'active': _ctx.activeIndex === index}, label]),
                        title: label
                      }, [
                        event
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.$emit(event)),
                              target: target
                            }, [
                              _withDirectives(_createElementVNode("img", {
                                src: icon,
                                alt: "svg image"
                              }, null, 8, _hoisted_13), [
                                [_directive_svg_inline]
                              ]),
                              _createElementVNode("span", null, _toDisplayString(label), 1)
                            ], 8, _hoisted_12))
                          : (dropdown && dropdown.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", {
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleManageDropdown()))
                                }, [
                                  (_ctx.activeIndex === index && iconActive)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                        _withDirectives(_createElementVNode("img", {
                                          src: iconActive,
                                          alt: "svg image"
                                        }, null, 8, _hoisted_15), [
                                          [_directive_svg_inline]
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                        _withDirectives(_createElementVNode("img", {
                                          src: icon,
                                          alt: "svg image"
                                        }, null, 8, _hoisted_17), [
                                          [_directive_svg_inline]
                                        ])
                                      ])),
                                  _createElementVNode("span", null, _toDisplayString(label), 1)
                                ]),
                                _withDirectives(_createElementVNode("img", {
                                  src: _ctx.arrowRightIcon,
                                  alt: "svg image"
                                }, null, 8, _hoisted_18), [
                                  [_directive_svg_inline]
                                ])
                              ], 64))
                            : (label === _ctx.HEADERS.EFNA || label === _ctx.HEADERS.REPORT)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createElementVNode("div", {
                                    onClick: ($event: any) => (_ctx.openSubMenus(label))
                                  }, [
                                    (_ctx.activeIndex === index && iconActive)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                          _withDirectives(_createElementVNode("img", {
                                            src: iconActive,
                                            alt: "svg image"
                                          }, null, 8, _hoisted_21), [
                                            [_directive_svg_inline]
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                          _withDirectives(_createElementVNode("img", {
                                            src: icon,
                                            alt: "svg image"
                                          }, null, 8, _hoisted_23), [
                                            [_directive_svg_inline]
                                          ])
                                        ])),
                                    _createElementVNode("span", null, _toDisplayString(label), 1)
                                  ], 8, _hoisted_19),
                                  _withDirectives(_createElementVNode("img", {
                                    src: _ctx.arrowRightIcon,
                                    alt: "svg image"
                                  }, null, 8, _hoisted_24), [
                                    [_directive_svg_inline]
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 3,
                                  onClick: ($event: any) => (_ctx.handleLinkClick(index))
                                }, [
                                  (_ctx.activeIndex === index && iconActive)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                        _withDirectives(_createElementVNode("img", {
                                          src: iconActive,
                                          alt: "svg image"
                                        }, null, 8, _hoisted_27), [
                                          [_directive_svg_inline]
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                        _withDirectives(_createElementVNode("img", {
                                          src: icon,
                                          alt: "svg image"
                                        }, null, 8, _hoisted_29), [
                                          [_directive_svg_inline]
                                        ])
                                      ])),
                                  _createElementVNode("span", null, _toDisplayString(label), 1)
                                ], 8, _hoisted_25))
                      ], 10, _hoisted_11))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to", "active", "href", "onClick"]))
            }), 128))
          ]),
          _createElementVNode("ul", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profileOptions, (item, i) => {
              return (_openBlock(), _createElementBlock("li", { key: i }, [
                _createElementVNode("a", {
                  class: _normalizeClass(item.label),
                  href: item.href ? item.href : undefined,
                  onClick: ($event: any) => (_ctx.handleEvent(item.event))
                }, [
                  (item.icon)
                    ? _withDirectives((_openBlock(), _createElementBlock("img", {
                        key: 0,
                        id: "profile",
                        src: item.icon,
                        alt: "svg image"
                      }, null, 8, _hoisted_32)), [
                        [_directive_svg_inline]
                      ])
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(item.label), 1)
                ], 10, _hoisted_31)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_33, _toDisplayString(this.currentUser.userPersonalInfo?.fullname), 1)
        ]),
        _createElementVNode("div", {
          class: "submenu-wrapper",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleEmptyAreaClick()))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["submenu", { 'open': _ctx.isEfnaMenuOpen }])
          }, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userAccessViews, (item, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  class: _normalizeClass({'hide': item.shouldHide}),
                  onClick: ($event: any) => (_ctx.handleEfnaRoute(item.href))
                }, _toDisplayString(item.label), 11, _hoisted_34))
              }), 128))
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["submenu", { 'open': _ctx.isReportMenuOpen}])
          }, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportOptions, (item, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  class: _normalizeClass({'hide': item.shouldHide}),
                  onClick: ($event: any) => (_ctx.handleRoute(item.href))
                }, _toDisplayString(item.label), 11, _hoisted_35))
              }), 128))
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["submenu", { 'open': _ctx.isManageMenuOpen }])
          }, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slicedItems, (menu, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (!menu.disable)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: index,
                        to: menu.url
                      }, {
                        default: _withCtx(() => [
                          (!menu.disable)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: index,
                                class: _normalizeClass(["link", { 'selected-menu': _ctx.currentRoute.startsWith(menu.url) }]),
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSubLinkClick && _ctx.handleSubLinkClick(...args)))
                              }, [
                                _createElementVNode("span", null, _toDisplayString(menu.label), 1),
                                (menu.img)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: menu.img
                                    }, null, 8, _hoisted_36))
                                  : _createCommentVNode("", true),
                                (menu.img)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: menu.img
                                    }, null, 8, _hoisted_37))
                                  : _createCommentVNode("", true)
                              ], 2))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ])
          ], 2),
          (_ctx.nextSlicedItems.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["subsubmenu", { 'open': _ctx.isManageMenuOpen } ])
              }, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nextSlicedItems, (menu, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (!menu.disable)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: index,
                            to: menu.url
                          }, {
                            default: _withCtx(() => [
                              (!menu.disable)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: index,
                                    class: _normalizeClass(["link", { 'selected-menu': _ctx.currentRoute.startsWith(menu.url) }]),
                                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleSubLinkClick && _ctx.handleSubLinkClick(...args)))
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(menu.label), 1),
                                    (menu.img)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: menu.img
                                        }, null, 8, _hoisted_38))
                                      : _createCommentVNode("", true),
                                    (menu.img)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: menu.img
                                        }, null, 8, _hoisted_39))
                                      : _createCommentVNode("", true)
                                  ], 2))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                ])
              ], 2))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    (_ctx.enableVirtualMeeting)
      ? (_openBlock(), _createBlock(_component_AppDialog, {
          key: 0,
          class: "virtual-meeting-url",
          onClosed: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isCopied = false)),
          hideFooter: true
        }, {
          header: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("Virtual Meeting URL")
          ])),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("p", null, [
                _cache[11] || (_cache[11] = _createTextVNode("Click on the URL to copy: ")),
                _createElementVNode("strong", null, _toDisplayString(_ctx.isCopied ? 'Copied!' : ''), 1)
              ]),
              _createElementVNode("div", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.copyUrl && _ctx.copyUrl(...args))),
                class: "jitsi-url"
              }, [
                _createElementVNode("input", {
                  id: "url",
                  value: _ctx.jitsiUrl,
                  readonly: ""
                }, null, 8, _hoisted_41)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isClosePopupVisible)
      ? (_openBlock(), _createBlock(_component_AlertPopup, {
          key: 1,
          showModal: _ctx.isClosePopupVisible,
          title: _ctx.noAccessDashboardAccessContent.title,
          message: _ctx.noAccessDashboardAccessContent.message,
          btnText: _ctx.noAccessDashboardAccessContent.btnText,
          type: _ctx.noAccessDashboardAccessContent.type,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isClosePopupVisible = false))
        }, null, 8, ["showModal", "title", "message", "btnText", "type"]))
      : _createCommentVNode("", true)
  ]))
}